import React from "react";
import styles from "./PlayerCard.module.css";
import icoCheck from '../../assets/ico-check.svg';
import icoTalent from '../../assets/flame-ico.svg';
import icoCreati from '../../assets/lamp-ico.svg';

const PlayerCard = ({ player, isRanking, disabled }) => {

    return (
        <div className={`${styles.borderCard} ${disabled ? styles.disabled : ''}`}>
            <div className={styles.playerCard}>
                <div className={styles.cardStripe}>
                    {/* Si no hay player, solo muestra el texto */}
                    {!player ? (
                        <div className={styles.waitingText}>Esperando usuario...</div>
                    ) : (
                        <>
                            {/* Imagen del jugador */}
                            <div className={styles.profilePicture}>
                                <img
                                    src={player.profilePicture || 'https://i.pinimg.com/200x150/a8/0e/36/a80e3690318c08114011145fdcfa3ddb.jpg'}
                                    alt={player.playerName}
                                />
                            </div>

                            {/* Nombre del jugador */}
                            <div className={styles.playerInfo} style={{ width: "40%" }}>
                                <div className={styles.textWrapper}>
                                    <h4 className={`${styles.name} ${styles.main}`}>
                                        {player.playerName}
                                    </h4>
                                </div>
                            </div>


                            {isRanking ?
                                <div className={styles.playerInfo} style={{ width: "32%" }}>
                                    <div className={styles.textWrapper}>
                                        <h4 className={`${styles.pts} ${styles.main}`}>
                                            {player.score} pts
                                        </h4>
                                    </div>
                                </div> : null}

                            {/* Estado del jugador */}
                            {player.status === 'ready' && (
                                <div className={isRanking ? styles.readyCheck : styles.readyCheckLobby}>
                                    <img src={icoCheck} alt="player ready" />
                                </div>
                            )
                            }
                        </>
                    )}
                </div>
            </div>
            {/* Renderizar medallas con el array de medallas del jugador */}
            {player && player.medallas && player.medallas.length > 0 && isRanking && (
                <div className={styles.contMedals}>
                    {player.medallas.map((medalType, index) => (
                        <div
                            key={index}
                            className={`${medalType === 'Talento' ? styles.medalTalent : styles.medalCreati} 
                                ${index === player.medallas.length - 1 ? styles.animatedMedal: ''}`}
                        >
                            <img src={medalType === 'Talento' ? icoTalent : icoCreati} alt={`Insignia de ${medalType}`} />
                        </div>
                    ))}
                </div>
            )}

        </div>
    );
};

export default PlayerCard;
